"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageManager = void 0;
/* eslint-disable prefer-arrow/prefer-arrow-functions */
function fixArrayType(array) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return array;
}
/* eslint-enable prefer-arrow/prefer-arrow-functions */
class StorageManager {
    constructor(storage, storageKey) {
        this.storage = storage;
        this.storageKey = storageKey;
    }
    async getAll() {
        return this.storage.get(this.storageKey);
    }
    async getOne(predicate) {
        const entities = await this.storage.get(this.storageKey);
        return fixArrayType(entities).find(predicate);
    }
    async addOne(element, predicate) {
        const entities = await this.storage.get(this.storageKey);
        if (!fixArrayType(entities).some(predicate)) {
            fixArrayType(entities).push(element);
        }
        return this.storage.set(this.storageKey, entities);
    }
    async remove(predicate) {
        const entities = await this.storage.get(this.storageKey);
        const filteredEntities = fixArrayType(entities).filter((entity) => !predicate(entity));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.storage.set(this.storageKey, filteredEntities);
    }
    async removeAll() {
        return this.storage.delete(this.storageKey);
    }
}
exports.StorageManager = StorageManager;
//# sourceMappingURL=StorageManager.js.map